<script>
import { h, Transition } from 'vue'

export default {
  render() {
    return h(
      Transition,
      {
        name: 'expand',
        onAfterEnter: (el) => {
          el.style.height = 'auto'
        },
        onEnter: (el) => {
          const { width } = getComputedStyle(el)
          el.style.width = width
          el.style.position = 'absolute'
          el.style.visibility = 'hidden'
          el.style.height = 'auto'

          const { height } = getComputedStyle(el)

          el.style.width = null
          el.style.position = null
          el.style.visibility = null
          el.style.height = 0

          getComputedStyle(el).height
          setTimeout(() => {
            el.style.height = height
          })
        },
        onLeave: (el) => {
          const { height } = getComputedStyle(el)

          el.style.height = height

          getComputedStyle(el).height
          setTimeout(() => {
            el.style.height = 0
          })
        }
      },
      this.$slots.default
    )
  }
}
</script>
